import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-add-email',
  imports: [FormsModule, ReactiveFormsModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './add-email.component.html',
})
export class AddEmailComponent {
  private modalRef = inject(NgbActiveModal);

  @Input() title = 'To';
  emailControl = new FormControl('', [Validators.required, Validators.email]);

  addEmail(e) {
    e.stopPropagation();
    e.preventDefault();

    if (!this.emailControl.valid) {
      return;
    }
    const email = this.emailControl.value;
    this.modalRef.close({ email });
  }

  close() {
    this.modalRef.close();
  }
}
